import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from './merchant-outbound-return-item-table-columns'

const propTypes = {
  data          : PropTypes.array,
  pagination    : PropTypes.object,
  onFetchData   : PropTypes.func,
  isLoading     : PropTypes.bool,
  hiddenColumns : PropTypes.arrayOf(PropTypes.string)
}

const defaultProps = {
  hiddenColumns : [],
  isLoading     : false
}

/**
 * Table to display specific Merchant Outbound Return Item columns
 */
const MerchantOutboundReturnItemTable = ({
  hiddenColumns,
  data,
  pagination,
  onFetchData,
  isLoading
}) => {
  const columns = useMemo(() => tableColumns({ data }),[ data ])

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

MerchantOutboundReturnItemTable.propTypes    = propTypes
MerchantOutboundReturnItemTable.defaultProps = defaultProps

export default MerchantOutboundReturnItemTable
